import React, { useState } from 'react';
import useDialogHandler from 'hooks/useDialogHandler';
import CompanyConversationDialogAsUser from 'domain/conversations/CompanyConversationDialogAsUser';
import Drawer from '@mui/material/Drawer';
import styles from './messages.scss';
import ChatBubblesIcon from 'ui/elements/icons/ChatBubblesIcon';
import { Conversation } from 'apis/CompanyAPI/conversations/conversationApi';
import UserConversationDialog from '../UserConversationDialog';
import { useConversationMe } from 'apis/CompanyAPI/conversations/useConversationMe';
import UserInboxContent from './UserInboxContent';
import { OrangeBadge } from 'ui/elements/OrangeBadge';
import { ICompany } from 'types/company';

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export const CONVERSATION_DRAWER_ID = 'conversation-drawer';

export default function UserInbox(props: Props) {
  const dialogHandler = useDialogHandler();

  const [activeChat, setActiveChat] = useState<Conversation | undefined>();
  const [companyProfiles, setCompanyProfiles] = useState<ICompany[]>([]);
  const { resource: meResource } = useConversationMe();
  const numUnread = meResource.state === 'fetched' ? meResource.resource.numUnread : 0;

  const companyId = activeChat?.type === 'user-company' ? activeChat.companyConversation.companyId : undefined;
  const company = companyId ? companyProfiles.find(c => c.id === companyId) : undefined;

  return (
    <>
      <button
        style={{ ...props.style }}
        data-intercom-target="user-inbox"
        className={props.className}
        onClick={dialogHandler.open}
      >
        <OrangeBadge badgeContent={numUnread > 0 ? numUnread : undefined}>
          <ChatBubblesIcon />
        </OrangeBadge>
      </button>
      {company && <CompanyConversationDialogAsUser onClose={() => setActiveChat(undefined)} company={company} />}
      {activeChat?.type === 'user-user' && (
        <UserConversationDialog
          conversation={{ type: 'existing', conversation: activeChat }}
          closeConversation={() => setActiveChat(undefined)}
          closeInbox={dialogHandler.close}
        />
      )}
      <Drawer
        id={CONVERSATION_DRAWER_ID}
        anchor="right"
        open={dialogHandler.isOpen}
        onClose={dialogHandler.close}
        PaperProps={{ className: styles.messageList }}
        disableEnforceFocus // input fields that are not handled by mui dialog are unselectable if this is removed
      >
        <UserInboxContent
          dialogHandler={dialogHandler}
          setActiveChat={setActiveChat}
          onCompanyProfilesLoaded={setCompanyProfiles}
        />
      </Drawer>
    </>
  );
}
